// Theme Specific Files

//codekit-prepend "../JR-Starter/general/jquery.js"
//codekit-prepend "../JR-Starter/general/scrollmagic.js"
//codekit-prepend "../JR-Starter/general/scrollmagic-indicators.js"
//@codekit-prepend "../JR-Starter/general/dzsparallaxer.js"
//@codekit-prepend "../JR-Starter/general/slick.js"
//@codekit-prepend "../JR-Starter/general/google-maps.js"
//@codekit-prepend "../JR-Starter/general/jquery.cookie.js"

//@codekit-prepend "../JR-Starter/jr-starter.js"

//@codekit-prepend "ww-currency-conversion.js"

//@codekit-prepend "magnific.js"

(function ($) {

	"use strict";

	var menuIsSticky = false,
		$window,
		$header,
		$body,
		$wpAdminBar,
		$searchButton,
		$searchField,
		$mainMenu,
		$collapseButton,
		$collapseClose,
		$wwFlags,
		$phone,
		$email;

	$(document).ready(jrDocumentReady);
	$(document).resize(jrResize);

	// Callback function for when the page is ready
	function jrDocumentReady() {

		$window = $(window);
		$body = $('body');
		$header = $('#jr-header');
		$wpAdminBar = $('#wpadminbar');
		$searchButton = $header.find('.search-icon button');
		$searchField = $header.find('input.search-field');
		$mainMenu = $header.find('.jr-menu');
		$wwFlags = $('#ww-flags');
		$phone = $header.find('.address-item-phone');
		$email = $header.find('.address-item-email');

		// Set parents
		$mainMenu.data('parent', $mainMenu.parent());
		$email.data('parent', $email.parent());
		$wwFlags.data('parent', $wwFlags.parent());
		$phone.data('parent', $phone.parent());
		

		//testStickyHeader();

		$window.scroll(function () {
			testStickyHeader();
		});

		$searchButton.click(function () {
			stickHeader(false, true);
			setTimeout(function () { $searchField.focus() }, 251);
		});



		// AJAX Page Sections
		var $entryContentWrapper = $('.entry-content-wrapper');

		$(".ww-sidebar a").on('click', function (e) {
			e.preventDefault();

			if ($(this).hasClass('active')) {
				return;
			}

			$(".ww-sidebar a").removeClass('active');

			var $this = $(this);

			var restURL = $this.data('rest');
			var urlPath = $this.attr('href');
			$entryContentWrapper.addClass('loading');
			$this.addClass('active');

			$.ajax({
				type: "GET",
				url: restURL,
				dataType: "JSON",
				success: function (response) {

					$entryContentWrapper.removeClass('loading');
					$('.entry-content-wrapper .entry-content').html(response.content.rendered);
					$('.entry-content-wrapper .title').html(response.title.rendered);

					var txt = document.createElement("textarea");
					txt.innerHTML = response.title.rendered + ' - Westminster Wire';

					var pageTitle = txt.value;
					window.history.pushState({ "html": $('#main').html(), "pageTitle": pageTitle }, "", urlPath);
					document.title =  pageTitle;
					
				}
			});

		});


		// Tabs 
		$('.layout-tabs .tab-titles li').on('click', function() {
			var $this = $(this);
			var content = $(this).data('content');
			$this.addClass('active');
			$this.siblings('li').removeClass('active');

			$this.parents('.tab-titles-wrapper').next('.tab-content-wrapper').find('.tab-content > li').removeClass('active');
			$this.parents('.tab-titles-wrapper').next('.tab-content-wrapper').find(content).addClass('active');
		});


		// Menu
		$collapseButton = $('<div class="collapse-menu"><i class="fa fa-bars" aria-hidden="true"></i> Menu</div>');
		$collapseClose = $('<div class="collapse-menu"><i class="fa fa-times" aria-hidden="true"></i></div>');
		$header.find('.navigation-menu').after($collapseButton);
		$header.find('.navigation-menu nav.jr-menu').append($collapseClose);
		$header.find('.search').clone().appendTo( $header.find('nav.jr-menu') );

		

		$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){

			
            if ( newSize !== 'large' ) {
				$body.addClass('collapse-menu');
				
			}

		});
		

		$header.find('div.collapse-menu').click( function() {

			var $mobileMenu = $('body > .jr-menu');

			if ( $mobileMenu.is(':visible') ) {
				$mobileMenu.hide();
			} else {
				$mobileMenu.css({display:'flex'});
			}

		});

		// Mobile Menu
		$mainMenu.on('click', 'li.menu-item-has-children > a', function(e) {
			
			/*
			if ( Foundation.MediaQuery.current === 'large' && is_touch_device() ) {

			} else {
				e.preventDefault();
				e.stopPropagation();
				$(this).parent().toggleClass('active');
				$(this).parent().find('.sub-menu-wrapper').slideToggle();
			}*/
			
			
		});

		$mainMenu.find('li.menu-item-has-children > a').click(function(e) {
			//e.preventDefault();
		});

		mobileMenu();

		$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize){
			mobileMenu();
		});

		// WooCommerce disable add to cart until colour selected
		var colourSelectField = $('.colour-select-field');

		if ( colourSelectField.length === 1 ) {

			var numberOfColours = colourSelectField.find('li').length;

		
			if (numberOfColours > 1) {
				var addToCart = $('.single_add_to_cart_button');
				addToCart.attr({
					'disabled' : 'disabled'
				}).html('Choose a colour');
	
				colourSelectField.on('change', function() {
					addToCart.html('Add to basket').removeAttr('disabled');
				});
			} else {
				colourSelectField.find('li input').attr('checked', 'checked');
			}
			
		}

		// Gallery
		$('.grid-type-gallery').magnificPopup({
			type: 'image',
			delegate: 'a',
			gallery:{
				enabled:true
			}
		});

		// Scroll indicator
		if ( $window.height() < $('#colophon').offset().top ) {
			$('.scroll-indicator').addClass('active');

			$window.scroll(function() {
				$('.scroll-indicator').removeClass('active');
			});
		}

		// Collapse categoris on small screens
		$('.widget .widgettitle').on('click', function() {

			if ( $(this).find('.chevron').length === 0 ) {
				return;
			}

			if ( Foundation.MediaQuery.current !== 'large' ) {
				
				if ( $(this).next().is(':visible') ) {
					$(this).removeClass('active');
					$(this).next().slideUp();
				} else {
					$(this).addClass('active');
					$(this).next().slideDown();
				}
			}
		});

		$(document).resize(jrResize);

		// Move onsale logo
		//$('.product .onsale').appendTo('.woocommerce-product-gallery');

		

	}

	function jrResize() {

		var $containers = $('.widget .chevron').parent('.widgettitle').next('ul');

		// Expand categories and product filters
		if ( Foundation.MediaQuery.current !== 'large' ) {
			$containers.hide();
		} else {
			$containers.show();
		}

	}

	function mobileMenu() {

		if ( Foundation.MediaQuery.current === 'small' || Foundation.MediaQuery.current === 'medium' ) {



			$mainMenu.after('<div id="main-menu-origin" style="display:none"></div>');
			$body.append($mainMenu);

			var lis = $mainMenu.children('li');
			

			

			// Flags
			$wwFlags.after('<div id="ww-flags-origin" style="display:none"></div>');
			$mainMenu.append($wwFlags);

			// Contact
			$email.after('<div id="email-origin" style="display:none"></div>');
			$mainMenu.prepend($email);

			$phone.after('<div id="phone-origin" style="display:none"></div>');
			$mainMenu.prepend($phone);

		} else if ( $('#main-menu-origin').length === 1 ) {

			
			$('#main-menu-origin').replaceWith($mainMenu);
			$('#ww-flags-origin').replaceWith($wwFlags);
			$('#email-origin').replaceWith($email);
			$('#phone-origin').replaceWith($phone);

		}
		
	}


	function testStickyHeader() {

		if ($window.scrollTop() <= 120) {

			if (menuIsSticky === false) {
				return;
			}

			menuIsSticky = false
			stickHeader(false);
			return;

		} else {

			if (menuIsSticky === true) {
				return;
			}

			menuIsSticky = true;
			stickHeader();
			return;

		}

	}

	function stickHeader(stick = true, force = false ) {

		if ( $body.hasClass('sticky-header-force') && ! force ) {
			return;
		}

		if (stick) {
			$body.addClass('sticky-header-active');
		} else {
			$body.removeClass('sticky-header-active');
		}

	}

	// When user uses back button
	window.onpopstate = function (e) {
		if (e.state) {
			$('#main').html(e.state.html);
			document.title = e.state.pageTitle;
			jrDocumentReady();

		}
	};

	function is_touch_device() {
		var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
		var mq = function(query) {
		  return window.matchMedia(query).matches;
		}
	  
		if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		  return true;
		}
	  
		// include the 'heartz' as a way to have a non matching MQ to help terminate the join
		// https://git.io/vznFH
		var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		return mq(query);
	}





}(jQuery));








